import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { PMField } from "../../../utils/PMField";
import ItemSelectorV2 from "../../../utils/Selector/ItemSelectorV2";
import { PMCustomSelector } from "../../../utils/PMCustomSelector";

export default function SystemForm(props) {
  const { formik, systemTypes, readOnly } = props;
  const { t } = useTranslation();

  const [productSelectorOpen, setProductSelectorOpen] = useState(false);
  const productSelectorFilters = useMemo(
    () => [{ name: "hasSpareParts", value: true }],
    []
  );

  const handleSystemTypeChange = (systemType) => {
    if (systemType) {
      formik.setFieldValue("system_type_id", systemType.id);
      formik.setFieldValue("system_type", systemType);
    } else {
      formik.setFieldValue("system_type_id", null);
      formik.setFieldValue("system_type", null);
    }
  };

  return (
    <div className="grid grid-cols-6 gap-6">
      <div className="col-span-6 sm:col-span-3">
        <PMCustomSelector
          name="system_type_id"
          label={t("System Type")}
          title={t("Select System Type")}
          description={t("Choose the type of system for this customer")}
          field="title"
          field2="description"
          field3="code"
          size="lg"
          dataSource={systemTypes}
          selected={formik.values.system_type}
          onChange={(data) => handleSystemTypeChange(data.target.data)}
          {...formik}
        />
      </div>

      <div className="col-span-6 sm:col-span-3">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
          <label> {t("Product")} </label>
        </label>
        <div
          className="cursor-pointer mt-1 block w-full p-2 border-0 border-b border-transparent bg-blue-50 focus:border-blue-500 focus:ring-0 sm:text-sm"
        >
          {formik.values.product?.title ? (
            <div className="font-bold p-2 border-b-4 border-indigo-300 flex items-center justify-between">
              <div onClick={!readOnly ? () => setProductSelectorOpen(true) : null}>
                {formik.values?.product?.item_number + " - "}
                {formik.values?.product?.title}
              </div>
              <div
                className="flex items-center justify-end"
                onClick={() => {
                  formik.setFieldValue("product_id", null);
                  formik.setFieldValue("product", null);
                }}
              >
                <XMarkIcon className="w-5 h-5" />
              </div>
            </div>
          ) : (
            <div
              className="text-gray-400"
              onClick={!readOnly ? () => setProductSelectorOpen(true) : null}
            >
              Velg produkt
            </div>
          )}
        </div>
        <div className="text-red-500 text-xs ">{formik.errors.product_id}</div>

        <ItemSelectorV2
          multiple={false}
          compact={true}
          open={productSelectorOpen}
          onClose={() => setProductSelectorOpen(false)}
          onChange={(data) => {
            if (data && data.length > 0) {
              const product = data[0];
              formik.setFieldValue("product_id", product.id);
              formik.setFieldValue("product", product);
              if (
                formik.values.system_m_name === null ||
                formik.values.system_m_name === "" ||
                formik.values.system_m_name === undefined
              ) {
                formik.setFieldValue("system_m_name", product.title);
              }
            }
          }}
          searchOnly
          hideCategoryAndSystemNav
          defaultShowActiveOnly={false}
          defaultShowExpired={true}
          searchPlaceholder={t("customer.system.product_search_placeholder")}
          filters={productSelectorFilters}
        />
      </div>

      <div className="col-span-6 sm:col-span-3">
        <PMField
          name="system_m_name"
          type="text"
          label={t("Model name")}
          readOnly={readOnly}
          {...formik}
        />
      </div>
      <div className="col-span-6 sm:col-span-3">
        <PMField
          name="serial_number"
          type="text"
          label={t("Serial Number")}
          readOnly={readOnly}
          {...formik}
        />
      </div>
      <div className="col-span-6 sm:col-span-3">
        <PMField
          name="placement"
          type="text"
          label={t("Placement")}
          readOnly={readOnly}
          {...formik}
        />
      </div>

      <div className="col-span-6 sm:col-span-3">
        <PMField
          name="installation_year"
          type="number"
          label={t("Installation Year")}
          readOnly={readOnly}
          {...formik}
        />
      </div>

      <div className="col-span-6 sm:col-span-3">
        <PMField
          name="production_year"
          type="number"
          label={t("Production Year")}
          readOnly={readOnly}
          {...formik}
        />
      </div>
    </div>
  );
}
